import React, {useState, useEffect, useCallback, useRef, useMemo} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {toGoogleMap, downloadFile, createNewTab, showToast, updateUTCDate, convertTzDate, utcToLocalDate, cutFloatlength} from '../../common/app_common';
import {InputAuto} from '../../common/component_common';
import { BsFullscreen, BsFullscreenExit, BsGeoAltFill, BsLink45Deg, BsDownload, BsFillPlusCircleFill, BsDashCircle, BsFillDashSquareFill } from 'react-icons/bs';
import {putApiSitesSiteConfig, postApiSites, getApiSitesKeyword} from '../../common/fetch_api/site';
import {getApiEdgeId, putApiEdgeIdConfig} from '../../common/fetch_api/edge';
import {getApiConfigTag, getApiConfigLocation} from '../../common/fetch_api/configuration';
import {postApiDataEndpoint, putApiDataEndpointId, delApiDataEndpointId} from '../../common/fetch_api/data_end_point';
import '../../common/css/markdown.css';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkToc from 'remark-toc';
import rehypeRaw from 'rehype-raw';
import rehypeHighlight from 'rehype-highlight';
import rehypeSanitize from 'rehype-sanitize';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

export const SiteCreateModal = ({show, handleClose, update}) => {
    
    const siteLocTxt = useRef('0, 0');
    const siteFrequencyTxt = useRef('');
    const excLocTxt = useRef('0, 0');
    const siteMemoTxt = useRef("");
    const [siteCallsign, setSiteCallsign] = useState('');
    const [siteMarket, setSiteMarket] = useState('');
    const [siteMemoLen, setSiteMemoLen] = useState(0);
    
    const [tabIndex, setTabIndex] = useState('Memo');
    const [markDown, setMarkDown] = useState('');
    
    const [siteLocation, setSiteLocation] = useState([]);
    const [excLocation, setExcLocation] = useState([]);
    const [transLocation, setTransLocation] = useState([]);
    const siteSelect = useRef(null);
    const excSelect = useRef(null);
    const transSelect = useRef(null);

    const [transmitList, setTransmitList] = useState(null);
    const transmitData = useRef([]);

    const [completeCallsign, setCompleteCallsign] = useState([]);
    const [completeMarket, setCompleteMarket] = useState([]);

    function makeTransmit(tranmit)
    {
        transmitData.current = tranmit;
        
        if(tranmit != null) {
            setTransmitList(tranmit.map((tm, index) =>
                <div key={index} className="station-list"><span className='station-name'>{tm.name}</span>
                    <BsFillDashSquareFill size={16} cursor={'pointer'} onClick={() => {onClickRemoveTansmit(tm.name)}}></BsFillDashSquareFill>
                </div>
            ));
        }
        else
        {
            setTransmitList(null);
        }
    }

    const onClickAddTansmit = () => {

        if( transSelect.current.value.length < 1 )
        {
            showToast('empty Transmission', 'warning');
            return;
        }
        
        const jsonData = JSON.parse(transSelect.current.value);
        let tranmitArr = transmitData.current;
        
        for(const transmit of tranmitArr)
        {
            if( transmit.name === jsonData.name )
            {
                showToast('exist Transmission', 'warning');
                return;
            }
        }

        tranmitArr.push({name: jsonData.name, latitude: jsonData.latitude, longitude: jsonData.longitude});
        makeTransmit(tranmitArr);
    }

    const onClickRemoveTansmit = (tm) => {
        let tranmitArr = transmitData.current.filter((x) => {return x.name !== tm});
        makeTransmit(tranmitArr);
    }

    const onClickSiteSave = () => {
        let location = siteLocTxt.current.value;
        let latitude = parseFloat(cutFloatlength(location.substr(0, location.search(','))));
        let longitude = parseFloat(cutFloatlength(location.substr(location.search(',') + 1)));
        let excLocation = excLocTxt.current.value;
        let excLatitude = parseFloat(cutFloatlength(excLocation.substr(0, excLocation.search(','))));
        let excLongitude = parseFloat(cutFloatlength(excLocation.substr(excLocation.search(',') + 1)));

        let sendInfo = {
            name : siteCallsign,
            market : siteMarket,
            latitude : latitude,
            longitude : longitude,
            frequency : siteFrequencyTxt.current.value === '' ? 0 : parseInt(siteFrequencyTxt.current.value),
            exciterLatitude : excLatitude,
            exciterLongitude : excLongitude,
            transmissionStationList : transmitData.current,
            memo : siteMemoTxt.current.value,
        }

        // console.log('sendInfo', sendInfo, siteFrequencyTxt.current.value);
        Promise.resolve( postApiSites(sendInfo) )        
        .then( done => {
            closeModal();
            setSiteCallsign('');
            setSiteMarket('');
            update();
        });
    }

    const onChangeSiteSel = () => {

        if( siteSelect.current.value !== '' )
        {
            siteLocTxt.current.value = siteSelect.current.value;
        }
    }

    const onChangeExcSel = () => {
        if( excSelect.current.value !== '' )
        {
            excLocTxt.current.value = excSelect.current.value;
        }
    }

    const onKeyUpsiteMemo = useCallback((e) => {
        setSiteMemoLen(siteMemoTxt.current.value.length);
        setMarkDown(siteMemoTxt.current.value);
    }, [siteMemoTxt]);

    useEffect( () => {
        Promise.resolve( getApiConfigLocation() )
        .then( data => {
            const site = data.filter((x) => {return x.type === 'Callsign'});
            const exc = data.filter((x) => {return x.type === 'Exciter'});
            const trans = data.filter((x) => {return x.type === 'Transmission'});

            setSiteLocation([
                <option key={-1} value={''}>Select Location</option>,
                site.map((item, index) => <option key={index} value={`${cutFloatlength(item.latitude)}, ${cutFloatlength(item.longitude)}`}>{item.name}</option>)
            ]);

            setExcLocation([
                <option key={-1} value={''}>Select Location</option>,
                exc.map((item, index) => <option key={index} value={`${cutFloatlength(item.latitude)}, ${cutFloatlength(item.longitude)}`}>{item.name}</option>)
            ]);

            setTransLocation([
                <option key={-1} value={''}>Select Location</option>,
                ...trans.map((item, index) => <option key={index} value={JSON.stringify({name: item.name, latitude:cutFloatlength(item.latitude), longitude:cutFloatlength(item.longitude)})} >{item.name}</option>)
            ]);
        });
        
        Promise.resolve( getApiSitesKeyword() )
        .then( data => {
            setCompleteCallsign(data.locationCallsign);
            setCompleteMarket(data.market);
        });
    }, []);
    
    const onClickSiteCancel = () => {
        setSiteCallsign('');
        setSiteMarket('');
        closeModal();
    }

    const closeModal = () => {
        setSiteMemoLen(0);
        setTabIndex('Memo');
        setMarkDown('');
        handleClose();
        show = false;
    }

    return (
        <Modal
            show={show}
            keyboard={true}
            onHide={onClickSiteCancel}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Create Site</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickSiteCancel}></Button>
            </Modal.Header>
            <Modal.Body className="create-site">
                <div className="d-flex">
                    <div className="col-3 label-box">Callsign</div>
                    <div className="col-9">
                        <InputAuto className="" pholder="" data={completeCallsign} selectedVal={siteCallsign} setSelectedVal={setSiteCallsign} />
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Market</div>
                    <div className="col-9">
                        <InputAuto className="" pholder="" data={completeMarket} selectedVal={siteMarket} setSelectedVal={setSiteMarket} />
                    </div>
                </div>
                <div className="d-flex site-location">
                    <div className="col-3 label-box">Site Location</div>
                    <div className="col-9 d-flex">
                        <input className="form-control input-box" type="text" defaultValue={'0,0'} ref={siteLocTxt}/>
                        <select className="form-select form-select-sm" ref={siteSelect} onChange={onChangeSiteSel}>
                            {siteLocation}
                        </select>
                        <Button variant='primary' className="btn btn-icon ms-1" onClick={() => {
                            siteLocTxt.current.value ? toGoogleMap(siteLocTxt.current.value) : showToast('Select or Input Location', 'warning');
                        }}><BsGeoAltFill /></Button>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Frequency</div>
                    <div className="col-9">
                        <input className="form-control input-box" type="text" ref={siteFrequencyTxt}/>
                        <span className='ms-2'>Mhz</span>
                    </div>
                </div>
                <div className="d-flex exciter-location">
                    <div className="col-3 label-box">Exciter Location</div>
                    <div className="col-9 d-flex">
                        <input className="form-control input-box" type="text" defaultValue={'0,0'} ref={excLocTxt}/>
                        <select className="form-select form-select-sm" ref={excSelect} onChange={onChangeExcSel}>
                            {excLocation}
                        </select>
                        <Button variant='primary' className="btn btn-icon ms-1" onClick={() => {
                            excLocTxt.current.value ? toGoogleMap(excLocTxt.current.value) : showToast('Select or Input Location', 'warning');
                        }}><BsGeoAltFill /></Button>
                    </div>
                </div>
                <div className="d-flex transmission-station">
                    <div className="col-3 label-box">Transmission Station</div>
                    <div className="col-9 d-flex">
                        <select className="form-select form-select-sm" ref={transSelect} >
                            {transLocation}
                        </select>
                        <Button variant='primary' className="btn btn-icon ms-1" onClick={onClickAddTansmit}><BsFillPlusCircleFill /></Button>
                        <Button variant='primary' className="btn btn-icon ms-1" onClick={() => {
                            transSelect.current.value ? toGoogleMap(`${JSON.parse(transSelect.current.value).latitude}, ${JSON.parse(transSelect.current.value).longitude}`) : showToast('Select Location', 'warning');
                        }}><BsGeoAltFill /></Button>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3"></div>
                    <div className="col-9">
                        <div className='transmission-list-box'>
                            {transmitList}
                        </div>
                    </div>
                </div>
                <Tabs
                    defaultActiveKey="Memo"
                    transition={true}
                    activeKey={tabIndex}
                    onSelect={(k) => setTabIndex(k)}
                    className="mt-3" >
                    <Tab eventKey="Memo" title="Memo"/>
                    <Tab eventKey="Editor" title="Editor"/>
                </Tabs>
                <div className={`d-flex manager-markdown-area mt-2 ${tabIndex === 'Memo'?'':'d-none'}`} >
                    <ReactMarkdown className='manager-text-box markdown-body'
                        children={markDown}
                        remarkPlugins={[remarkGfm, remarkToc]}
                        rehypePlugins={[rehypeRaw, rehypeHighlight, rehypeSanitize]}
                    />
                </div>
                <div className={`d-flex manager-markdown-area mt-2 ${tabIndex === 'Editor'?'':'d-none'}`} >
                    <textarea className="manager-text-box" maxLength="65535" ref={siteMemoTxt} onChange={onKeyUpsiteMemo}></textarea>
                </div>
                <div className="text-end">{`${siteMemoLen} / 65535`}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickSiteCancel}>Cancel</Button>
                <Button variant="success" className="btn-sm" onClick={onClickSiteSave}>Save</Button>
            </Modal.Footer>
        </Modal>
    )
}

export const SiteEditModal = ({siteInfo, show, handleClose, update}) => {
    
    const siteLocTxt = useRef('0, 0');
    const siteFrequencyTxt = useRef('');
    const excLocTxt = useRef('0, 0');
    const siteMemoTxt = useRef("");
    const [siteMarket, setSiteMarket] = useState('');
    const [siteMemoLen, setSiteMemoLen] = useState(0);
    
    const [tabIndex, setTabIndex] = useState('Memo');
    const [markDown, setMarkDown] = useState('');
    
    const [siteLocation, setSiteLocation] = useState([]);
    const [excLocation, setExcLocation] = useState([]);
    const [transLocation, setTransLocation] = useState([]);
    const siteSelect = useRef(null);
    const excSelect = useRef(null);
    const transSelect = useRef(null);

    const [transmitList, setTransmitList] = useState(null);
    const transmitData = useRef([]);

    const [completeCallsign, setCompleteCallsign] = useState([]);
    const [completeMarket, setCompleteMarket] = useState([]);

    function makeTransmit(tranmit)
    {
        transmitData.current = tranmit;
        
        if(tranmit != null) {
            setTransmitList(tranmit.map((tm, index) =>
                <div key={index} className="station-list"><span className='station-name'>{tm.name}</span>
                    <BsFillDashSquareFill size={16} cursor={'pointer'} onClick={() => {onClickRemoveTansmit(tm.name)}}></BsFillDashSquareFill>
                </div>
            ));
        }
        else
        {
            setTransmitList(null);
        }
    }

    const onClickAddTansmit = () => {

        if( transSelect.current.value.length < 1 )
        {
            showToast('empty Transmission', 'warning');
            return;
        }

        const jsonData = JSON.parse(transSelect.current.value);
        let tranmitArr = transmitData.current;
        
        for(const transmit of tranmitArr)
        {
            if( transmit.name === jsonData.name )
            {
                showToast('exist Transmission', 'warning');
                return;
            }
        }

        tranmitArr.push({name: jsonData.name, latitude: jsonData.latitude, longitude: jsonData.longitude});
        makeTransmit(tranmitArr);
    }

    const onClickRemoveTansmit = (tm) => {
        let tranmitArr = transmitData.current.filter((x) => {return x.name !== tm});
        makeTransmit(tranmitArr);
    }

    const onClickSiteSave = () => {
        let location = siteLocTxt.current.value;
        let latitude = parseFloat(cutFloatlength(location.substr(0, location.search(','))));
        let longitude = parseFloat(cutFloatlength(location.substr(location.search(',') + 1)));
        let excLocation = excLocTxt.current.value;
        let excLatitude = parseFloat(cutFloatlength(excLocation.substr(0, excLocation.search(','))));
        let excLongitude = parseFloat(cutFloatlength(excLocation.substr(excLocation.search(',') + 1)));

        let sendInfo = siteInfo;
        sendInfo.market = siteMarket;
        sendInfo.latitude = latitude;
        sendInfo.longitude = longitude;
        sendInfo.frequency = parseInt(siteFrequencyTxt.current.value);
        sendInfo.exciterLatitude = excLatitude;
        sendInfo.exciterLongitude = excLongitude;
        sendInfo.transmissionStationList = transmitData.current;
        sendInfo.memo = siteMemoTxt.current.value;

        Promise.resolve( putApiSitesSiteConfig(siteInfo.name, sendInfo) )        
        .then( done => {
            closeModal();
            update();
        });
    }

    const onChangeSiteSel = () => {
        if( siteSelect.current.value !== '' )
        {
            siteLocTxt.current.value = siteSelect.current.value;
        }
    }

    const onChangeExcSel = () => {
        if( excSelect.current.value !== '' )
        {
            excLocTxt.current.value = excSelect.current.value;
        }
    }

    const onKeyUpsiteMemo = useCallback((e) => {
        setSiteMemoLen(siteMemoTxt.current.value.length);
        setMarkDown(siteMemoTxt.current.value);
    }, [siteMemoTxt]);

    useEffect( () => {
        Promise.resolve( getApiConfigLocation() )
        .then( data => {
            const site = data.filter((x) => {return x.type === 'Callsign'});
            const exc = data.filter((x) => {return x.type === 'Exciter'});
            const trans = data.filter((x) => {return x.type === 'Transmission'});

            setSiteLocation([
                <option key={-1} value={''}>Select Location</option>,
                site.map((item, index) => <option key={index} value={`${cutFloatlength(item.latitude)}, ${cutFloatlength(item.longitude)}`}>{item.name}</option>)
            ]);

            setExcLocation([
                <option key={-1} value={''}>Select Location</option>,
                exc.map((item, index) => <option key={index} value={`${cutFloatlength(item.latitude)}, ${cutFloatlength(item.longitude)}`}>{item.name}</option>)
            ]);

            setTransLocation([
                <option key={-1} value={''}>Select Location</option>,
                ...trans.map((item, index) => <option key={index} value={JSON.stringify({name: item.name, latitude:cutFloatlength(item.latitude), longitude: cutFloatlength(item.longitude)})} >{item.name}</option>)
            ]);
        });
        
        Promise.resolve( getApiSitesKeyword() )
        .then( data => {
            setCompleteCallsign(data.locationCallsign);
            setCompleteMarket(data.market);
        });

        setSiteMarket(siteInfo.market);
    }, []);
    
    useEffect(() => {
        if( siteInfo )
        {
            if(siteInfo.memo != null) {
                setMarkDown(siteInfo.memo);
                setSiteMemoLen(siteInfo.memo.length);
            }
            
            makeTransmit(siteInfo.transmissionStationList);
        }
    }, [show, siteInfo]);
    
    const onClickSiteCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        setSiteMemoLen(0);
        setTabIndex('Memo');
        setMarkDown('');
        handleClose();
        show = false;
    }

    return (
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Edit Site</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickSiteCancel}></Button>
            </Modal.Header>
            <Modal.Body className="edit-site">
                <div className="d-flex">
                    <div className="col-3 label-box">Callsign</div>
                    <div className="col-9">
                        <input className="form-control input-box" value={siteInfo.name} readOnly/>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Market</div>
                    <div className="col-9">
                        <InputAuto className="" pholder="" data={completeMarket} selectedVal={siteMarket} setSelectedVal={setSiteMarket} />
                    </div>
                </div>
                <div className="d-flex site-location">
                    <div className="col-3 label-box">Site Location</div>
                    <div className="col-9 d-flex">
                        <input className="form-control input-box" type="text" ref={siteLocTxt} defaultValue={`${cutFloatlength(siteInfo.latitude)}, ${cutFloatlength(siteInfo.longitude)}`}/>
                        <select className="form-select form-select-sm" ref={siteSelect} onChange={onChangeSiteSel}>
                            {siteLocation}
                        </select>
                        <Button variant='primary' className="btn btn-icon ms-1" onClick={() => {
                            siteLocTxt.current.value ? toGoogleMap(siteLocTxt.current.value) : showToast('Select or Input Location', 'warning');
                        }}><BsGeoAltFill /></Button>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Frequency</div>
                    <div className="col-9">
                        <input className="form-control input-box" type="text" ref={siteFrequencyTxt} defaultValue={siteInfo.frequency}/>
                        <span className='ms-2'>Mhz</span>
                    </div>
                </div>
                <div className="d-flex exciter-location">
                    <div className="col-3 label-box">Exciter Location</div>
                    <div className="col-9 d-flex">
                        <input className="form-control input-box" type="text" ref={excLocTxt} defaultValue={`${cutFloatlength(siteInfo.exciterLatitude)}, ${cutFloatlength(siteInfo.exciterLongitude)}`}/>
                        <select className="form-select form-select-sm" ref={excSelect} onChange={onChangeExcSel}>
                            {excLocation}
                        </select>
                        <Button variant='primary' className="btn btn-icon ms-1" onClick={() => {
                            excLocTxt.current.value ? toGoogleMap(excLocTxt.current.value) : showToast('Select or Input Location', 'warning');
                        }}><BsGeoAltFill /></Button>
                    </div>
                </div>
                <div className="d-flex transmission-station">
                    <div className="col-3 label-box">Other Exciter Location</div>
                    <div className="col-9 d-flex">
                        <select className="form-select form-select-sm" ref={transSelect} >
                            {transLocation}
                        </select>
                        <Button variant='primary' className="btn btn-icon ms-1" onClick={onClickAddTansmit}><BsFillPlusCircleFill /></Button>
                        <Button variant='primary' className="btn btn-icon ms-1" onClick={() => {
                            transSelect.current.value ? toGoogleMap(`${JSON.parse(transSelect.current.value).latitude}, ${JSON.parse(transSelect.current.value).longitude}`) : showToast('Select Location', 'warning');
                        }}><BsGeoAltFill /></Button>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3"></div>
                    <div className="col-9">
                        <div className='transmission-list-box'>
                            {transmitList}
                        </div>
                    </div>
                </div>
                <Tabs
                    defaultActiveKey="Memo"
                    transition={true}
                    activeKey={tabIndex}
                    onSelect={(k) => setTabIndex(k)}
                    className="mt-3" >
                    <Tab eventKey="Memo" title="Memo"/>
                    <Tab eventKey="Editor" title="Editor"/>
                </Tabs>
                <div className={`d-flex manager-markdown-area mt-2 ${tabIndex === 'Memo'?'':'d-none'}`} >
                    <ReactMarkdown className='manager-text-box markdown-body'
                        children={markDown}
                        remarkPlugins={[remarkGfm, remarkToc]}
                        rehypePlugins={[rehypeRaw, rehypeHighlight, rehypeSanitize]}
                    />
                </div>
                <div className={`d-flex manager-markdown-area mt-2 ${tabIndex === 'Editor'?'':'d-none'}`} >
                    <textarea className="manager-text-box" maxLength="65535" ref={siteMemoTxt} onChange={onKeyUpsiteMemo} defaultValue={siteInfo.memo}></textarea>
                </div>
                <div className="text-end">{`${siteMemoLen} / 65535`}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickSiteCancel}>Cancel</Button>
                <Button variant="success" className="btn-sm" onClick={onClickSiteSave}>Save</Button>
            </Modal.Footer>
        </Modal>
    )
}

export const EdgeInfoModal = ({edgeId, show, handleClose}) => {
    const [fullscreen, setFullscreen] = useState(false);
    const [edgeRecvData, setEdgeRecvData] = useState(null);
    const [checkinDate, setCheckinDate] = useState('');

    const checkWarning = () => {
        
        let curTime = new Date();
        let checkIn = new Date(0);
        checkIn.setUTCSeconds(edgeRecvData.sec);

        return `${(curTime.getTime() - checkIn.getTime()) >= 60000? "text-warning":""}`;
    }
    
    const onClickSiteCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
        setFullscreen(false);
    }

    const onClickToggleFull = () => {
        setFullscreen(!fullscreen);
    }
    
    useEffect(() => {

        Promise.resolve( getApiEdgeId(edgeId) )
        .then( edgeInfo => {
            setEdgeRecvData(edgeInfo);

            let checkIn = new Date(0);
            checkIn.setUTCSeconds(edgeInfo.sec);
            setCheckinDate(updateUTCDate(checkIn));
        });

    }, []);

    return (        
        <Modal
            show={show}
            fullscreen={fullscreen}
            keyboard={true}
            onHide={closeModal}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Detail</h6>
                <div>
                    {!fullscreen&&<BsFullscreen cursor={'pointer'} onClick={onClickToggleFull}></BsFullscreen>}
                    {fullscreen&&<BsFullscreenExit cursor={'pointer'} onClick={onClickToggleFull}></BsFullscreenExit>}
                    <Button variant='close' className="btn-close-white" onClick={closeModal}></Button>
                </div>
            </Modal.Header>
            <Modal.Body>
                {edgeRecvData && <>
                    <div className="d-flex">
                        <div className="col-3 label-box">EdgeId</div>
                        <div className="col-9">
                            <input className="form-control input-box" type="text" value={edgeRecvData.id} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">Fingerprint</div>
                        <div className="col-9">
                            <input className="form-control input-box" type="text" value={edgeRecvData.fingerprint} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">Type</div>
                        <div className="col-9">
                            <input className="form-control input-box" type="text" value={edgeRecvData.type} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">EdgeName</div>
                        <div className="col-9">
                            <input className="form-control input-box" type="text" value={edgeRecvData.name} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">Site</div>
                        <div className="col-9">
                            <input className="form-control input-box" type="text" value={edgeRecvData.site} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">Tag</div>
                        <div className="col-9">
                            <input className="form-control input-box" type="text" value={edgeRecvData.tag} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">ClientIp</div>
                        <div className="col-9">
                            <input className="form-control input-box" type="text" value={edgeRecvData.clientIp} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">Collect Type</div>
                        <div className="col-9">
                            <input className="form-control input-box" type="text" value={edgeRecvData.collectType} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">Link</div>
                        <div className="col-9">
                            <input className="form-control input-box" type="text" value={edgeRecvData.link} readOnly/>
                            <Button variant='primary' className="btn btn-icon ms-1" onClick={() => {
                                createNewTab(edgeRecvData.link);
                            }}><BsLink45Deg /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">Lastest Check in</div>
                        <div className="col-9">
                            <input className={`form-control input-box ${checkWarning()}`}  type="text" value={checkinDate} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">Created Date</div>
                        <div className="col-9">
                            <input className="form-control input-box" type="text" value={utcToLocalDate(convertTzDate(edgeRecvData.date))} readOnly/>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">Location</div>
                        <div className="col-9">
                            <input className="form-control input-box" type="text" value={`${edgeRecvData.latitude}, ${edgeRecvData.longitude}`} readOnly/>
                            <Button variant='primary' className="btn btn-icon ms-1" onClick={() => {
                                toGoogleMap(`${edgeRecvData.latitude}, ${edgeRecvData.longitude}`);
                            }}><BsGeoAltFill /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">Memo</div>
                        <div className="col-9 d-flex manager-memo-area mb-2">
                            <ReactMarkdown className='manager-mark-down markdown-body'
                                children={edgeRecvData.memo}
                                remarkPlugins={[remarkGfm, remarkToc]}
                                rehypePlugins={[rehypeRaw, rehypeHighlight, rehypeSanitize]}
                                readOnly
                            />
                            <Button variant='primary' className="btn btn-icon ms-1" onClick={() => {
                                downloadFile(edgeRecvData.memo, `${edgeRecvData.name}_Memo`);
                            }}><BsDownload /></Button>
                        </div>
                    </div>
                    <div className="d-flex">
                        <div className="col-3 label-box">Metrics</div>
                        <div className="col-9 d-flex">
                            <textarea className="modal-textarea" value={edgeRecvData.metrics} readOnly></textarea>
                            <Button variant='primary' className="btn btn-icon ms-1" onClick={() => {
                                downloadFile(edgeRecvData.metrics, `${edgeRecvData.name}_Metrics`);
                            }}><BsDownload /></Button>
                        </div>
                    </div>
                </>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' className="btn-sm" onClick={onClickSiteCancel}>Close</Button>
                <Button variant='success' className="btn-sm" onClick={() => {
                    downloadFile(`Id\t${edgeRecvData.id}\nDeviceId\t${edgeRecvData.deviceId}\nType\t${edgeRecvData.type}\nDeviceName\t${edgeRecvData.name}\nSiteName\t${edgeRecvData.site}\nStatus\t${edgeRecvData.status}\nTag\t${edgeRecvData.tag}\nPublicIp\t${edgeRecvData.clientIp}\nLink\t${edgeRecvData.link}\nSec\t${edgeRecvData.sec}\nDate\t${edgeRecvData.date}\nLatitude, Longitude\t${edgeRecvData.latitude}, ${edgeRecvData.longitude}\nLatitude, Longitude (Manual)\t${edgeRecvData.manualLatitude}, ${edgeRecvData.manualLongitude}\nLocationMode\t${edgeRecvData.locationMode}\nMemo\t${edgeRecvData.memo}\nMetrics\t${edgeRecvData.metrics}`, `${edgeRecvData.name}_DetailAll`);
                }}>Export</Button>
            </Modal.Footer>
        </Modal>
    );
};

export const EdgeEditModal = ({siteInfo, edgeId, show, handleClose, update}) => {
    const [edgeData, setEdgeData] = useState(null);

    const edgeLink = useRef(null);
    const [edgeTag, setEdgeTag] = useState('');
    const edgeLocMode = useRef(null);
    const edgeLocTm = useRef(null);
    const edgeLocValue = useRef(null);
    const edgeMemo = useRef(null);
    const [edgeMemoLen, setEdgeMemoLen] = useState(0);

    const [tagList, setTagList] = useState(null);
    const [siteTmList, setSiteTmList] = useState(null);
    const [edgeLocModeTxt, setEdgeLocModeTxt] = useState('0');

    const [tabIndex, setTabIndex] = useState('Memo');
    const [markDown, setMarkDown] = useState('');

    const onChangeTag =(e) => {
        setEdgeTag(e.target.value);
    }
    
    const onClickSiteCancel = () => {
        closeModal();
    }

    const onChangeLocation = () => {
        const mode = edgeLocMode.current.value;
        setEdgeLocModeTxt(mode);

        if( mode === 'site' )
        {
            edgeLocValue.current.value = `${siteInfo.latitude}, ${siteInfo.longitude}`;
        }
        else if( mode === 'exciter' )
        {
            edgeLocValue.current.value = `${siteInfo.exciterLatitude}, ${siteInfo.exciterLongitude}`;
        }
        else if( mode === 'transmissionStation' )
        {
            if( siteInfo.transmissionStationList.length > 0 )
            {
                const loc = edgeLocTm.current.value;
                const list = [...siteInfo.transmissionStationList].filter( (item) => {return item.name === loc})[0];

                edgeLocValue.current.value = `${list.latitude}, ${list.longitude}`;
            }
            else
            {
                edgeLocValue.current.value = "0, 0";
            }
        }
        else
        {
            edgeLocValue.current.value = `${edgeData.latitude}, ${edgeData.longitude}`;
        }
    }

    const onChangeLocTm = () => {        
        const loc = edgeLocTm.current.value;
        const list = [...siteInfo.transmissionStationList].filter( (item) => {return item.name === loc})[0];

        edgeLocValue.current.value = `${list.latitude}, ${list.longitude}`;
    }

    const onKeyUpsiteMemo = useCallback((e) => {
        setEdgeMemoLen(edgeMemo.current.value.length);
        setMarkDown(edgeMemo.current.value);
    }, [edgeMemo]);

    function makeTagList(tagName)
    {
        Promise.resolve( getApiConfigTag() )
        .then( data => {
            if( data )
            {
                setTagList(data.map((tag, index) =>
                    <option key={index} value={tag}>{tag}</option>
                ));

                setEdgeTag(tagName);
            }
        });
    }
    
    function makeTransmitList(tranmit)
    {
        if(tranmit != null) {
            setSiteTmList(tranmit.map((tm, index) =>
                <option key={index} value={tm.name}>{tm.name}</option>
            ));
        }
    }

    const onClickEdgeSave = () => {

        let location = edgeLocValue.current.value;
        let latitude = parseFloat(location.substr(0, location.search(',')));
        let longitude = parseFloat(location.substr(location.search(',') + 1));

        let sendInfo = {
            longitude:longitude,
            latitude:latitude,
            locationMode: edgeLocMode.current.value,
            transmissionStation: '',
            memo: edgeMemo.current.value,
            link: edgeLink.current.value,
            tag: edgeTag
        };
        
        if( edgeLocMode.current.value === 'transmissionStation' )
        {
            sendInfo.transmissionStation = edgeLocTm.current.value;
        }

        Promise.resolve( putApiEdgeIdConfig(edgeId, sendInfo) )        
        .then( done => {
            closeModal();
            update();
        });
    }
    
    const onClickDeviceCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    useEffect(() => {
        Promise.resolve( getApiEdgeId(edgeId) )
        .then( edgeInfo => {

            setEdgeData(edgeInfo);

            let mode = edgeInfo.locationMode;
            edgeLink.current.value = edgeInfo.link;
            edgeLocMode.current.value = mode;
            setEdgeLocModeTxt(mode);
            
            if( mode === 'site' )
            {
                edgeLocValue.current.value = `${siteInfo.latitude}, ${siteInfo.longitude}`;
            }
            else if( mode === 'exciter' )
            {
                edgeLocValue.current.value = `${siteInfo.exciterLatitude}, ${siteInfo.exciterLongitude}`;
            }
            else if( mode === 'transmissionStation' )
            {
                edgeLocValue.current.value = `${edgeInfo.latitude}, ${edgeInfo.longitude}`;
            }
            else
            {
                edgeLocValue.current.value = `${edgeInfo.latitude}, ${edgeInfo.longitude}`;
            }
            edgeMemo.current.value = edgeInfo.memo;
            setEdgeMemoLen(edgeInfo.memo.length);
            setMarkDown(edgeInfo.memo);

            makeTagList(edgeInfo.tag);
            makeTransmitList(siteInfo.transmissionStationList);
            edgeLocTm.current.value = edgeInfo.transmissionStation;
        });
    }, [show, edgeId]);

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            id="edgeDetailEditModal"
            >
            <Modal.Header>
                <h6 className="modal-title">{`${edgeData?edgeData.name:''}`}</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickSiteCancel}></Button>
            </Modal.Header>
            <Modal.Body className='edit-edge-detail'>
                <div className="d-flex">
                    <div className="col-3 label-box">Link</div>
                    <div className="col-9">
                        <input className="form-control input-box" type="text" ref={edgeLink}/>
                        <Button variant='primary' className="btn btn-icon ms-1" onClick={() => {
                            createNewTab(edgeLink.current.value);
                        }}><BsLink45Deg /></Button>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Tag</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" value={edgeTag} onChange={onChangeTag}>
                            <option value=''>none</option>
                            {tagList}
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Location</div>
                    <div className="col-9">
                        <div className="d-flex flex-column edge-location">
                            <div className='d-flex'>
                                <select className="form-select form-select-sm me-1" ref={edgeLocMode} onChange={onChangeLocation}>
                                    <option value="manual">Manual</option>
                                    <option value="site">Site</option>
                                    <option value="exciter">Exciter</option>
                                    <option value="transmissionStation">Transmission Station</option>
                                </select>
                                <input className="form-control input-box" type="text" ref={edgeLocValue}
                                    readOnly={`${edgeLocModeTxt!=='manual'?'readOnly':''}`}/>
                                <Button variant='primary' className="btn btn-icon ms-1" onClick={() => {
                                    toGoogleMap(edgeLocValue.current.value);
                                }}><BsGeoAltFill /></Button>
                            </div>
                            <div className='d-flex'>
                                <select className={`form-select form-select-sm my-1 ${edgeLocModeTxt==='transmissionStation'?'':'d-none'}`} defaultValue={''} ref={edgeLocTm} onChange={onChangeLocTm}>
                                    {siteTmList}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <Tabs
                    defaultActiveKey="Memo"
                    transition={true}
                    activeKey={tabIndex}
                    onSelect={(k) => setTabIndex(k)}
                    className="mt-3" >
                    <Tab eventKey="Memo" title="Memo"/>
                    <Tab eventKey="Editor" title="Editor"/>
                </Tabs>
                <div className={`d-flex manager-markdown-area ${tabIndex === 'Memo'?'':'d-none'}`} >
                    <ReactMarkdown className='manager-text-box markdown-body'
                        children={markDown}
                        remarkPlugins={[remarkGfm, remarkToc]}
                        rehypePlugins={[rehypeRaw, rehypeHighlight, rehypeSanitize]}
                    />
                </div>
                <div className={`d-flex manager-markdown-area ${tabIndex === 'Editor'?'':'d-none'}`} >
                    <textarea className="manager-text-box" maxLength="65535" ref={edgeMemo} onChange={onKeyUpsiteMemo} ></textarea>
                </div>
                <div className="text-end">{`${edgeMemoLen} / 65535`}</div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickDeviceCancel}>Close</Button>
                <Button variant="success" className="btn-sm" onClick={onClickEdgeSave}>Save</Button>
            </Modal.Footer>
        </Modal>
    );
};

function sendScrapeInterval(value)
{
    switch(parseInt(value))
    {
        case 0:
        {
            return 3;
        }
        case 1:
        {
            return 5;
        }
        case 2:
        {
            return 10;
        }
        case 3:
        {
            return 15;
        }
        case 4:
        {
            return 30;
        }
        default:
        {
            return 3;
        }
    }
}

export const DataEndPointCreate = ({show, handleClose, updateContents}) => {

    const typeRef = useRef('');
    const nameRef = useRef('');
    const uriRef = useRef('');
    const intvRef = useRef('');

    const onClickConfirm = () => {
        let type = typeRef.current.value;
        let name = nameRef.current.value;
        let uri = uriRef.current.value;
        let intv = intvRef.current.value;

        Promise.resolve(postApiDataEndpoint({'type': type, 'name': name, 'uri': uri, 'scrapeInterval': sendScrapeInterval(intv)}))
        .then( done => {
            closeModal();
            updateContents();
        })
        .catch( err => {});
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Create DataEndpoint</h6>
                <Button variant='close' className="btn-close-white" onClick={onClickCancel}></Button>
            </Modal.Header>
            <Modal.Body className='create-data-endpoint'>
                <div className="d-flex">
                    <div className="col-3 label-box">Type</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" ref={typeRef}>
                            <option value="s-agent">S-Agent</option>
                            <option value="m-agent">M-Agent</option>
                            <option value="rm">RM</option>
                        </select>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Name</div>
                    <div className="col-9">
                        <input className="form-control input-box" type="text" ref={nameRef}/>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">URI</div>
                    <div className="col-9">
                        <input className="form-control input-box" type="text" ref={uriRef}/>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">ScrapeInterval</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" ref={intvRef}>
                            <option value="0">3sec</option>
                            <option value="1">5sec</option>
                            <option value="2">10sec</option>
                            <option value="3">15sec</option>
                            <option value="4">30sec</option>
                        </select>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Cancel</Button>
                <Button variant="success" className="btn-sm" onClick={onClickConfirm}>Create</Button>
            </Modal.Footer>
        </Modal>
    );
};

export const DataEndPointEdit = ({dataEndPointData, show, handleClose, updateContents}) => {

    const typeRef = useRef('');
    const nameRef = useRef('');
    const uriRef = useRef('');
    const intvRef = useRef('');

    const onClickConfirm = () => {
        let uri = uriRef.current.value;
        let intv = intvRef.current.value;

        Promise.resolve(putApiDataEndpointId(dataEndPointData.id, {'uri': uri, 'scrapeInterval': sendScrapeInterval(intv)}))
        .then( done => {
            closeModal();
            updateContents();
        })
        .catch( err => {});
    }

    const onClickDelete = () => {
        Promise.resolve( delApiDataEndpointId(dataEndPointData.id) )
        .then( done => {
            closeModal();
            updateContents();
        })
        .catch( err => {});
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
    }

    useEffect(() => {
        if(dataEndPointData)
        {
            typeRef.current.value = dataEndPointData.type;
            nameRef.current.value = dataEndPointData.name;
            uriRef.current.value = dataEndPointData.uri;
            intvRef.current.value = dataEndPointData.scrapeInterval;
        }
    }, [dataEndPointData, show]);

    return (        
        <Modal
            show={show}
            keyboard={true}
            onHide={closeModal}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Edit DataEndpoint</h6>
            </Modal.Header>
            <Modal.Body className="edit-data-endpoint">
                <div className="d-flex">
                    <div className="col-3 label-box">Type</div>
                    <div className="col-9">
                        <input className="form-control input-box" type="text" ref={typeRef} readOnly/>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">Name</div>
                    <div className="col-9">
                        <input className="form-control input-box" type="text" ref={nameRef} readOnly/>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">URI</div>
                    <div className="col-9">
                        <input className="form-control input-box" type="text" ref={uriRef}/>
                    </div>
                </div>
                <div className="d-flex">
                    <div className="col-3 label-box">ScrapeInterval</div>
                    <div className="col-9">
                        <select className="form-select form-select-sm" ref={intvRef}>
                            <option value="0">3sec</option>
                            <option value="1">5sec</option>
                            <option value="2">10sec</option>
                            <option value="3">15sec</option>
                            <option value="4">30sec</option>
                        </select>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Cancel</Button>
                <Button variant="danger" className="btn-sm" onClick={onClickDelete}>Delete</Button>
                <Button variant="success" className="btn-sm" onClick={onClickConfirm}>Save</Button>
            </Modal.Footer>
        </Modal>
    );
};

export const ModalSample = ({show, handleClose, updateContents, setUpdateContents}) => {
    const [fullscreen, setFullscreen] = useState(false);

    useEffect(() => {
    }, []);

    const onClickConfirm = () => {
    }

    const onClickCancel = () => {
        closeModal();
    }

    const closeModal = () => {
        handleClose();
        show = false;
        setFullscreen(false);
    }

    const onClickToggleFull = () => {
        setFullscreen(!fullscreen);
    }

    return (        
        <Modal
            show={show}
            fullscreen={fullscreen}
            keyboard={true}
            onHide={closeModal}
            // backdrop="static"
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header>
                <h6 className="modal-title">Sample</h6>
                <div>
                    {!fullscreen&&<BsFullscreen cursor={'pointer'} onClick={onClickToggleFull}></BsFullscreen>}
                    {fullscreen&&<BsFullscreenExit cursor={'pointer'} onClick={onClickToggleFull}></BsFullscreenExit>}
                    <Button variant='close' className="btn-close-white" onClick={closeModal}></Button>
                </div>
            </Modal.Header>
            <Modal.Body>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="btn-sm" onClick={onClickCancel}>Cancel</Button>
                <Button variant="success" className="btn-sm" onClick={onClickConfirm}>OK</Button>
            </Modal.Footer>
        </Modal>
    );
};